import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-thanks-message-point-summary" }
const _hoisted_2 = { class: "p-thanks-message-point-summary__meta" }
const _hoisted_3 = { class: "date" }
const _hoisted_4 = { class: "p-thanks-message-point-summary__unread" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextLabelThanksMessageUnread = _resolveComponent("TextLabelThanksMessageUnread")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.formatDate), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_ctx.unreadCount > 0)
        ? (_openBlock(), _createBlock(_component_TextLabelThanksMessageUnread, {
            key: 0,
            count: _ctx.displayUnreadCount
          }, null, 8, ["count"]))
        : _createCommentVNode("", true)
    ])
  ]))
}